import {FormSetting, ShareMethod} from '../app/pages/UserPages/wallet-card/type'
import {BusinessNumber, CustomNumber, DedicatedNumber as V1DedicatedNumber} from './cellcast.type'
import {WalletCardTemplateDetail} from '../app/pages/UserPages/wallet-card-templates/types'
import { Flow } from '../app/pages/UserPages/contact-collection/type'

export enum ContactStatus {
  subscribe = 'subscribe',
  unsubscribe = 'unsubscribe',
}

export enum AllocateCreditSubClientMode {
  add = 'add',
  remove = 'remove',
}

export enum CampType {
  sms = 'sms',
  mms = 'mms',
}

export enum TransactionHistoryStatus {
  Credit = 'credit',
  Debit = 'debit',
}

export enum TokenStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum WebhookType {
  Receive = 'receive',
  Status = 'status',
  Unsubscribe = 'unsubscribe',
}

export enum GetSubClientShareCreditMode {
  Day = 'day',
  Month = 'month',
}

export enum SmppStatus {
  Active = 'active',
  NotActive = 'not-active',
}

export enum AutomationRule {
  messageStartsWith = 'messageStartsWith',
  messageContains = 'messageContains',
  messageEquals = 'messageEquals',
  anyMessage = 'anyMessage',
  anyMessageOptOut = 'anyMessageOptOut',
  includeTag = 'includeTag',
  excludeTag = 'excludeTag',
  anyTag = 'anyTag',
}

export enum AutomationPipelineType {
  addTag = 'addTag',
  unsubscribe = 'unsubscribe',
  forwardReply = 'forwardReply',
  sendSms = 'sendSms',
}

export enum QuickAPICreditUsage {
  REQUEST_NAME = 'request_name',
}

export enum BulkMatrixType {
  bounceRate = 'bounce_rate',
  ctrRate = 'ctr_rate',
  replyRate = 'reply_rate',
  unsubscribeRate = 'unsubscribe_rate',
}

export enum SalesGroupByEnum {
  industry = 'industry',
  sales = 'sales',
  source = 'source',
}

export interface AppResponse<T> {
  app_type: string
  app_version: string
  maintainence: number
  new_version: number
  force_update: number
  invalid_token: number
  refresh_token: string
  show_message: number
  is_enc: boolean
  status: boolean
  message: string
  message_type: string
  data: T
  error: Record<string, any>
}

export interface PaginateResponse<T> {
  items: T[]
  total: number
  limit: number
  current: number
  totalPages: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}

export interface PaginateParams {
  page: number
  limit: number
}

// ----- Task Management -----
export type TaskStatus = 'pending' | 'completed'
export type TaskPriority = 'low' | 'medium' | 'high'

export interface TaskAssignedUser {
  _id: string
  name: string
  email?: string
  ownerId?: string
  timeZone?: string
}

export interface TaskLinkedContactField {
  name: string
  value: string
}

export interface TaskLinkedContact {
  id: string
  fields?: TaskLinkedContactField[]
  number?: string
  fullName?: string
}

export interface TaskItem {
  id: string
  _id?: string
  title: string
  description?: string
  status: TaskStatus
  dueDate: string
  setUpReminder: boolean
  reminderMinutesBeforeDue?: number
  priority: TaskPriority
  assignedTo?: TaskAssignedUser | null
  contacts?: TaskLinkedContact[] | null
  completedAt?: string | null
  completedBy?: TaskAssignedUser | null
  notificationSent?: boolean
  reminderNotificationSent?: boolean
  createdAt: string
  updatedAt: string
}

export interface TaskListResponse extends PaginateResponse<TaskItem> {}

export type TaskApiResponse<T> = {
  success: boolean
  message: string
  data: T
  type?: string
}

export type GetTasksParams = {
  page?: number
  limit?: number
  search?: string
  status?: TaskStatus
  priority?: TaskPriority
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  user?: string
  assignedTo?: string
  quickFilter?: 'all' | 'due-today' | 'overdue' | 'upcoming' | 'completed'
}

export type CreateTaskPayload = {
  title: string
  description?: string
  dueDate: string | Date
  priority?: TaskPriority
  assignedTo?: string | null
  contacts?: string[]
  leads?: string[]
  setUpReminder?: boolean
  reminderMinutesBeforeDue?: number
}

export type UpdateTaskPayload = Partial<Omit<CreateTaskPayload, 'dueDate'>> & {
  title?: string
  dueDate?: string | Date
  status?: TaskStatus
}

export type UpdateTaskRequest = {
  id: string
  data: UpdateTaskPayload
}

export type DeleteMultipleTasksPayload = {
  ids: string[]
}

export type CompleteMultipleTasksPayload = {
  ids: string[]
}

export type TaskStatsResponse = {
  totalTasks: number
  pendingTasks: number
  completedTasks: number
  overdueTasks: number
  upcomingTasks: number
  dueTodayTasks: number
}

export type GetTaskStatsParams = {
  user?: string
}

//----- Request Param and Response
// Contact
export type GetContactParams = {
  // nextCursor?: string
  // prevCursor?: string
  page?: number | string
  limit?: number
  groupId?: string
  tag?: string | undefined
  staticTag?: string | undefined
  excludeTag?: string | undefined
  staticExcludeTag?: string | undefined
  status?: ContactStatus | string | undefined
  search?: string | undefined
  sortKey?: string | undefined
  sortValue?: string | undefined
  searchFieldsName?: string | undefined
  searchFieldsValue?: string | undefined
  number?: string
} & {
  [key in `searchFieldsNames[${number}]` | `searchFieldsValues[${number}]`]?: string
}

export type GetContactCountParams = Omit<GetContactParams, 'nextCursor' | 'prevCursor' | 'limit'>
export type ExportContactsParams = {
  query: Omit<GetContactParams, 'page' | 'limit'>
  body: {
    contactIDs: string[]
  }
}

export type DeleteContactsParams = {
  query: Omit<GetContactParams, 'page' | 'limit'>
  body: {
    contactIDs: string[]
    allContact: boolean
  }
}
export type DeleteContactsResponse = AppResponse<Group>

export type GetContactListResponse = AppResponse<ListContactResponse>
export type GetContactCountResponse = AppResponse<number>
export type ExportContactResponse = AppResponse<{
  downloadurl: string
}>

export type ExportResponse = AppResponse<{
  downloadurl: string
}>

export type ContactDetail = ContactGroupMap & {
  contact: Contact
  tags: Tag[]
}
export type GetContactDetailResponse = AppResponse<ContactDetail>

export type ContactDetailMessage = {
  allSendMessage: number
  receivedMessage: number
  repliesMessage: number
}
export type GetContactDetailMessageResponse = AppResponse<ContactDetailMessage>

export type ContactDetailClickThrough = {
  total: number
  shortLinkClick: number
  landingPageClick: number
}
export type GetContactDetailClickThroughResponse = AppResponse<ContactDetailClickThrough>

// Sub Accounts
export type ActivateDeactivateSubClientParam = {
  userId: string
}

export type DnGracePeriodSettingParam = {
  userId: string
}

export type DnGracePeriodSetting = {
  status: boolean
  monthly: number
  yearly: number
}

export type DnGracePeriodSettingResponse = AppResponse<DnGracePeriodSetting>

// Dedicated Number Custom Price Types
export type DedicatedNumberCustomPriceParam = {
  userId: string
}

export type DedicatedNumberCustomPrice = {
  status: 'active' | 'deactive'
  monthly?: number
  yearly?: number
}

export type DedicatedNumberCustomPriceData = {
  userId: string
  name: string
  email: string
  dedicatedNumberCustomPrice: DedicatedNumberCustomPrice | null
}

export type DedicatedNumberCustomPriceResponse = AppResponse<DedicatedNumberCustomPriceData>

export type GetSubClientsParam = {
  page?: number | string
  limit?: number
  search?: string
  industry?: string
  status?: string
}

export type GetSubClientsResponse = AppResponse<PaginateResponse<SubClientItem>>

export type GetSubClientParam = {id: string}
export type GetSubClientResponse = AppResponse<SubClient>

export type CreateSubClient = {
  customLogo?: string | File
  avatar?: string | File
  email: string
  mobile: string
  name: string
  website?: string
  password: string
  accountManager: string
  accountType: string
  sales: string
  companyName: string
  industry: string
  features: string | string[]
  notes: string
  accountId?: string
  isSharingCredit: boolean
  isEmailVerified: boolean
}

export type UpdateSubClientData = Omit<CreateSubClient, 'password'>

export type UpdateSubClient = {
  id: string
  data: UpdateSubClientData
}

export type UpdatePasswordParam = {
  id: string
  password: string
}
export type UpdatePasswordResponse = AppResponse<{
  message: string
}>

export type UpdateStatusParam = {
  id: string
  status: string
}
export type UpdateStatusResponse = AppResponse<{
  message: string
}>

export type DeleteSubClient = {id: string}

export type LoginAsSubClientResponse = AppResponse<{
  user: SubClient
  userPermissions: string[]
  isEmailVerified: boolean
  isMobileVerified: boolean
  token: string
  refreshToken: string
}>
export type LoginBackSubClientResponse = LoginAsSubClientResponse

export type AllocateCreditSubClientParam = {
  id: string
  data: {
    mode: AllocateCreditSubClientMode
    amount: number
    campType: CampType
  }
}
export type AllocateCreditSubClientResponse = AppResponse<string>

export type GetCreditOverviewResponse = AppResponse<CreditOverview>

export type GetTransactionHistoryParams = {
  id: string
  data: {
    page?: number | string
    limit?: number
    campType?: CampType | string
    status?: TransactionHistoryStatus | string
  }
}

export type GetTransactionHistoryResponse = AppResponse<PaginateResponse<CreditTransaction>>

export type CreateApiTokenParams = {
  id: string
  data: {
    name: string
  }
}
export type CreateApiTokenResponse = AppResponse<Pick<ApiToken, 'name' | 'token'>>

export type GetApiTokensResponse = AppResponse<ApiToken[]>

export type UpdateTokenStatusParams = {
  id: string
  data: {
    status: TokenStatus
    tokenId: string
  }
}

export type UpdateTokenStatusResponse = AppResponse<ApiToken>

export type DeleteTokenParams = {
  id: string
  data: {
    tokenId: string
  }
}
export type DeleteTokenResponse = UpdateTokenStatusResponse

export type SetWebhookParams = {
  id: string
  data: {
    type: WebhookType
    url: string
  }
}

export type SetWebhookResponse = AppResponse<WebHook[]>

export type getTotalSpendCredit = {
  campType: CampType
  fromDate: string
  toDate: string
}

export interface HustleFollowupSuggestion {
  suggestion: string | null
  reason?: string
}

export type SubClientSetCreditParams = {
  id: string
  data: SubClientCreditLimit & {mode?: string}
}

export type SubClientSetCreditResponse = AppResponse<SubClientCreditLimit>

export type SubClientShareCreditRemainingResponse = AppResponse<{
  mode: GetSubClientShareCreditMode
  credit: {
    sms: number
    mms: number
  }
}>

export type AllocateSubClientDedicatedNumberWriteParams = {
  id: string
  dedicatedNumberId: string
}

export type AllocateSubClientBusinessNumberWriteParams = {
  id: string
  businessNumberId: string
}

export type AllocateSubClientCustomNumberWriteParams = {
  id: string
  customNumberId: string
}

export type DedicatedNumber = V1DedicatedNumber & {
  allocatedUsers: string[]
}

export type SubClientDedicatedNumberResponse = AppResponse<DedicatedNumber[]>
export type SubClientBusinessNumberResponse = AppResponse<BusinessNumber[]>
export type SubClientCustomNumberResponse = AppResponse<CustomNumber[]>

export type GetListParams = {
  page?: number
  limit?: number
  usePaginate?: boolean
  search?: string
}

export type GetListCountResponse = AppResponse<
  {
    id: string
    count: number
  }[]
>

// Admin Credit
export type AdminRemoveCreditParams = {
  campType: CampType
  userId: string
  noOfCredit: number
  note?: string
}

// Message Report
export type MessageReportParams = {
  fromDate?: string
  toDate?: string
  status?: string
  campType?: CampType
  sortKey?: string
  sortValue?: string
  page?: number
  limit?: number
  type?: string
  groupBy?: string
  isExport?: boolean
  receiver?: string
  requestFrom?: string
  requestFromExclude?: string
  requestName?: string
}

export type MessageReportItems = {
  _id: string
  medium: string
  status: string
  replyStop: boolean
  message: string
  sender: string
  receiver: string
  smsDetail: {
    _id: string
    messagelength: number
    smscount: number
    costpersms: number
    deductibleCredit: number
  }
  creditAmount: number
  media?: [
    {
      _id: string
      filetype: string
      url: string
    }
  ]
  replyMessage: MessageReportItems | null
  request_from: string
  request_name: string
  gateway_count: number
  createdAt: string
  total?: number
  totalCreditAmount?: number
  totalSms?: number

  customerResponse?: string
  customerResponseAt?: string
  customerResponseMedia?: [
    {
      _id: string
      filetype: string
      url: string
    }
  ]

  created_at?: string
  message_part?: number
  credit_amount?: number
  type?: string
  response_message?: {
    id?: string
    message?: string
    receive_at?: string
    media?:
      | [
          {
            file?: string
            url?: string
          }
        ]
      | null
  }
  canceledAt?: string
  scheduleAt?: string
  send_time?: string
  response_time?: string
  response_state?: string
  campaign_type?: string
}

export type MessageReportResponse = AppResponse<PaginateResponse<MessageReportItems>>

// multi step automation
export type GetListMultiStepAutomationResponse = AppResponse<
  PaginateResponse<Automation> & {
    tags: Tag[]
  }
>
export type GetListMultiStepAutomationParams = PaginateParams & {
  search?: string
  rule?: AutomationRule
}

//----- Entity
interface ListContactResponse {
  items: ContactGroupMap[]
  next: number
  prev: number
}

export interface ContactGroupMap {
  _id: string
  number: string
  group: Group
  contact: Contact
  user: string
  name: string | null
  fields: Field[]
  createdAt: string
  updatedAt?: string
  blockedByUserAt?: string
  lastMessage?: string
  tags: Tag[]
  cursor?: string
  creatorName: string
  createdFrom: string
  isBlocked: boolean
  isBlockedByUser: boolean
  bounced: number

  /**V3 */
  is_blocked?: boolean
  creator_name?: string
  created_from?: string
  full_number?: string
}

export interface Group {
  fields: string[]
  _id: string
  user: string
  name: string
  status: string
  mergeLabels: string
  createdBy: string
  totalContacts: string
}

export interface Contact {
  _id: string
  number: string
  countryCode: string
  // isBlocked: boolean
  // isBlockedByUser: boolean
  bounced: number
  addedThrough: string
  isInboxRead: boolean
}

interface Field {
  name: string
  value: string
  length: number
  isEnglish: boolean
}

export interface Tag {
  _id: string
  name: string
  type: string
  color: string
  createdAt?: string
  updatedAt?: string
}

export interface List extends Tag {}

export interface CreditOverview {
  allocatedSms: number
  allocatedMms: number
  usedSms: number
  usedMms: number
  purchasedSms: number
  purchasedMms: number
}

// Sub Account
export interface SubClientItem {
  _id: string
  active: boolean
  status: string
  companyName: string
  industry: string
  accountType: string
  features: string[]
  sales: string
  notes: string
  lastLogin: string
  name: string
  firstName: string
  lastName: string
  mobile: string
  email: string
  avatar: string
  createdAt: string
  status2: string
  isSharingCredit: boolean
  credit: CreditOverview
}

interface Shopify {
  amountRecovered: number
  _id: string
  isActive: boolean
}

interface Communication {
  email: boolean
  phone: boolean
  _id: string
}

interface WebHook {
  _id: string
  type: WebhookType
  url: string
}

export interface SubClient {
  active: boolean
  status2: string
  status: string
  trail: number
  contactLimit: number
  senders: string[]
  mobileSenders: string[]
  defaultSender: string
  allowedSharedSender: boolean
  type: string
  profile: string
  allowReceivedSmsAsEmail: boolean
  isSpecialPlanActive: boolean
  isoCode: string
  countryCode: string
  emailSmsSubjectSetting: number
  smsStartTag: string[]
  smsEndTag: string[]
  shopify: Shopify
  isEmailVerified: boolean
  isMobileVerified: boolean
  isCreditAllow: boolean
  autoCredit: boolean
  autoCreditAmount: number
  companyName: string
  industry: string
  language: string
  accountType: string
  loginMethod: string
  communication: Communication
  allowMarketing: boolean
  features: string[]
  designation: string
  profile_pic: string
  accountManager: string
  sales: string
  notes: string
  deleted: boolean
  lastLogin: string
  ownerMainUserId: string
  commissionRate: number | null
  earnedCommissionAmt: number
  isWhiteLabelUser: boolean
  smsStatus: string
  globalSetting: string[]
  isReadFirstMessageApproval: boolean
  _id: string
  name: string
  firstName: string
  lastName: string
  mobile: string
  email: string
  role: string
  roleId: string
  currency: string
  companyWebsite: string
  accountId: string
  avatar: string
  customLogo: string
  ownerId: string
  subAccountId: string
  webHooks: WebHook[]
  deliveryReportId: string
  externalAuthKey: string
  zapierHooks: string[]
  createdAt: string
  updatedAt: string
  subClientLimitConfig?: SubClientCreditLimit
  region?: string
  subClientAccountId?: string
  __v: number
}

export interface CreditTransaction {
  addedBy: string
  _id: string
  creditAmount: number
  type: string
  user: string
  description: string
  balance: number
  status: string
  createdAt: string
  updatedAt: string
  __v: number
}

export interface ApiToken {
  status: TokenStatus
  createdAt: string
  _id: string
  token: string
  name: string
}

export interface SubClientCreditLimit {
  smsLimitPerDay: number
  mmsLimitPerDay: number
  smsLimitPerMonth: number
  mmsLimitPerMonth: number
}

// AutomationPipeline interface
export interface AutomationPipeline {
  type: AutomationPipelineType
  order?: number
  config?: Record<string, any> // Assuming config can be any object structure
}

// Automation interface
export interface Automation {
  _id?: string
  trigger: string
  title: string
  status: boolean
  rule: AutomationRule
  message?: string
  email?: string
  searchTerm?: string | string[]
  incomingSMS?: boolean
  type?: 'single' | 'multi'
  user?: string // Assuming you are using ObjectId from mongoose
  pipelines?: AutomationPipeline[]
  createdBy?: string
  createdAt?: Date // Since timestamps are enabled
  updatedAt?: Date // Since timestamps are enabled
}

export interface CreditUsage {
  _id?: string // Represents the type, e.g., "sms"
  totalUsedCredit: number // Represents the total used credit amount
}

export interface UpdateMany {
  n: number
  nModified: number
  ok: number
}

// referral
export enum myReferralCode {
  NotSet = 'not-set',
  WaitingApproval = 'waiting-approval',
  Active = 'active',
  Rejected = 'rejected',
  Inactive = 'inactive',
}

export enum CommissionType {
  Credit = 'credit',
  Money = 'money',
}

export interface SubmitReferralCodeApproval {
  notificationId: string
  status: string
}

export interface ConfigureReferralCommissionParams {
  userId: string
  rate: number
  type: CommissionType
}

export interface SubmitReferralCode {
  code: string
}

export interface Affiliate {
  _id: string

  companyName: string
  name: string
  email: string
  createdAt: string

  referralCode: string
  referralParentAccessResponseAt: string
  referralParentAccessStatus: string
}

export type CommissionListParams = PaginateParams & {
  userId?: string
  affiliateId?: string
  commissionType?: string
  campType?: string
  fromDate?: string
  toDate?: string
}

export interface SendQuickMessage {
  to?: string[]
  contacts?: string[]
  replyTo: string
  subject: string
  templateId: string
  message: string
  longUrls: string[]
  landingPage: boolean
  landingPageId: string
  optout: boolean
  optoutId: string
  replyStopToOptOut: boolean
}
export interface BulkSummarySendEmailResponse {
  draftDeductibleCredits: number
  emailcount: number
  costperemail: number
  totalContactCount: number
}

export interface BulkSendEmail {
  ulid: string
  sender: string
  message: string
  camp_type: string
  name: string
  type?: string
  landingPage: boolean
  optout: boolean
  replyStopToOptOut: boolean
  messageSecond?: string
  landingPageSecond?: boolean
  optoutSecond?: boolean
  replyStopToOptOutSecond?: boolean
  replyTo: string
  subject: string
  templateId?: string
  to:
    | string
    | {
        selectedType: string
        value: string | string[]
      }
  when: string
  interval?: number
  isIntervalSend?: boolean
  scheduledAt?: string
  quantity?: number
  staggerMessages?: boolean
}
export type CommissionAmountParams = {
  affiliateId?: string
  commissionType: string
  campType?: string
  fromDate?: string
  toDate?: string
}

export interface Commission {
  _id: string
  user: string
  affiliateUser: string
  type: string
  camp_type: string
  rate: number
  top_up_amount: number
  amount: number
  createdAt: string
  updatedAt: string
  __v: number
  affiliateUserData: Pick<Affiliate, '_id' | 'name'>
}

export interface CommissionAmount {
  totalAmount: number
}

// short link
export type ShortLinkFilterParam = PaginateParams & {
  code?: string
  bulkId?: string
  click?: number
  fromDate?: string
  toDate?: string
  shortUrl?: string
}

interface ShortLinkBulkData {
  _id: string
  name: string
}

interface ShortLinkLandingPageData {
  _id: string
  campaignName: string
}

export interface Analytic {
  gatewaymessage?: string
  user?: string
  number?: string
  shortCode: string
  contactId?: string
  click?: number
  shorturl?: string
  status?: boolean
  bulk?: string
  bulkData?: ShortLinkBulkData
  ip?: string
  country?: string
  countrycode?: string
  fullUrl: string
  lat?: string
  lng?: string
  browser?: string
  platform?: string
  mobile?: string
  information?: any
  createdAt?: Date
  updatedAt?: Date
}

export interface ShortLink {
  _id: string
  shortUrl: string
  upstreamUrl: string
  status?: string
  createdAt?: Date
  click: number
  expireAt?: Date
}

export interface LandingPageShortCode {
  gatewaymessage?: string
  gatewaymms?: string
  user?: string
  number?: string
  shortCode: string
  contactId?: string
  bulkId?: string
  bulkData?: ShortLinkBulkData
  ownerId?: string
  landingPageId?: string
  landingPageData?: ShortLinkLandingPageData
  response?: string[]
  responseCreatedAt?: Date
  fullUrl: string
  click?: number
  ip?: string
  browser?: string
  platform?: string
  mobile?: string
  createdAt?: Date
  updatedAt?: Date
}

export interface LandingPageChart {
  series: number[]
  label: string[]
  bulkIds: {label: string; value: string}[]
}

// sender options
export type SenderOption = {
  value: string
  label: string
  type: string
}

export type SenderOptions = {
  sms: SenderOption[]
  mms: SenderOption[]
}

export type TotalConctacts = {
  totalContacts: number
  inboundCount: number
  outboundCount: number
}
// ----- bulk report -----
export interface MessageSchedule {
  to: {
    value: string[]
    selectedType: string
  }
  optout: boolean
  replyStopToOptOut: boolean
  campaign_type: string
  contacts: string[]
  deductibleCredits: number
  active: boolean
  costpersms: number
  staggerMessages: boolean
  landingPage: boolean
  scheduledNames: string[]
  _id: string
  name: string
  message: string
  longUrl: string[]
  sender: string
  media: {
    _id: string
    filetype: string
    url: string
  }[]
  mediaType: string
  scheduleAt: string
  queueJobId: string
  status: string
  user: string
  camp_type: string
  senderType: string
  recipients: number
  staggerId: string
  interval: number
  quantity: number
  createdAt: string
  updatedAt: string
  scheduleAtDate: Date
}

export type GetStaggerMessageResponse = AppResponse<MessageSchedule[]>

export type BulkMatrixParams = {
  type?: BulkMatrixType
}

export type BulkMatrixResponse = AppResponse<{
  value: number
  type: string
  growthRate: number
}>

interface ContactFormTag {
  tagId: string
  name: string
}

interface ContactFormTagField {
  name: string
  type: string
}

export interface ContactForm {
  _id: string
  name: string
  description: string
  tags: ContactFormTag[]
  fields: ContactFormTagField[]
  isActive: boolean
  isUseDailyCaptureData: boolean
  isAutoDeleteContact: boolean
  isMarketingMessageOptIn: boolean
  marketingMessageOptin: string
  logo: any
  redirectUrl: string
}

export interface RawContact {
  id: string
  fullName: string
  email: string
  phone: string
  source: string
  tags?: string[]
  note?: string
  cardName: string
  createdAt: string
}

export interface RawContactSearch {
  page?: number
  limit?: number
  search?: string
  filter?: string
  dateType?: 'day' | 'week' | 'month'
  lastReplyMessageExists?: boolean
  sales?: boolean
  sortBy?: string
  sortOrder?: string
}
export interface CardData {
  id?: string
  type: string
  organizationName?: string
  cardName: string
  fullName: string
  jobTitle?: string
  companyName?: string
  address?: string
  phone: string
  email: string
  website?: string
  shareMethod: ShareMethod[]
  logo?: string
  picture?: string
  pictureGoogle?: string
  backgroundImage?: string
  user: string
  backgroundColor: string
  foregroundColor: string
  labelColor: string
  aiWelcomeMessage?: boolean
}

export interface CardTemplateList {
  items: WalletCardTemplateDetail[]
  total: number
  limit: number
  current: number
}

export interface CreateWalletCardTemplate {
  type: string
  organizationName: string
  cardName: string
  cardLabel: string
  fullName: string
  jobTitle?: string
  companyName?: string
  address?: string
  phone: string
  email: string
  website?: string
  shareMethod: ShareMethod[]
  logo?: string
  picture?: string
  pictureGoogle?: string
  backgroundImage?: string
  user: string
  backgroundColor: string
  foregroundColor: string
  labelColor: string
  imagePreviewUrl?: string
  promoSettings: PromoAction[]
  vehicleTypeOptions?: string[]
  formSettings: FormSetting[]
  formBackgroundColor: string
  formLabelColor: string
  contactIconColor: string
  template?: string | null
  isDefault: boolean
}

export interface VehicleTypeOption {
  id?: string
  _id?: string
  name?: string
  description?: string
  color?: string
  user?: string
}

export interface ContactData {
  id?: string
  fullName: string
  phone: string
  email: string | null
  address?: string
  companyName?: string
  jobTitle?: string
  website?: string
  interestedVehicleType?: string | null
  interestedVehicleTypes?: string[]
  notes?: string
  source: string
  sales: boolean
  assignedTo: string | {
    name: string
    _id: string
  } | null
  user: string
  tags?: string[]
  targetId?: string
  createdAt?: string
  updatedAt?: string
  promoSettings?: string[]
  intent?: string | null
  sentiment?: string
  noteText?: string
  noteVoice?: string | null
  welcomeMessage?: string
  welcomeMessageReminderSent?: boolean
  welcomeMessageReminderSentAt?: string
  flows?: Flow[] | null
  value?: number | null
  callLastTime?: string
  aiSummaryNote?: string | null
  statusAiSummaryNote?: string | null
}

export interface MetricEntry {
  date: string
  value: number
}

export interface TotalScan {
  viaWallet: MetricEntry[]
  viaContact: MetricEntry[]
}

export interface Metrics {
  newLeads: {
    total: number
    data: MetricEntry[]
  }
  fromWallet: {
    total: number
    data: MetricEntry[]
  }
  fromContact: {
    total: number
    data: MetricEntry[]
  }
  scanWalletCard: {
    total: number
    data: MetricEntry[]
  }
  totalScan: TotalScan
}

export interface DateRange {
  startDate: string
  endDate: string
}

export interface AnalyticsResponse {
  dateRange: DateRange
  metrics: Metrics
}

export interface ExportRawContactList {
  downloadurl: string
}
export interface PromoAction {
  id: string
  name: string
  user?: string
  industry?: string
  affiliate?: string
  rawContactCount?: number
  createdAt?: string
  updatedAt?: string
}

export interface PromoActionResponse {
  items: PromoAction[]
  total: number
  limit: number
  current: number
}

export interface VehicleTypeOptionResponse {
  items: VehicleTypeOption[]
  total: number
  limit: number
  current: number
  totalPages?: number
}
export interface PromoActionResponse {
  items: PromoAction[]
  total: number
  limit: number
  current: number
}

export interface SavedSequence {
  id: string
  name: string
  createdAt: string
  camp_type?: string[]
}

export interface DeleteSavedSequenceParams {
  id: string
}

export type ContactFormInput = Omit<ContactForm, '_id'>

// Sales
export type SalesPurchaseFilter = {
  from: string
  to: string
  page: number
  limit: number
  mode?: 'list' | 'export'
  source?: string
}

export type SalesNewPurchase = {
  accountManager: string
  sales: string
  _id: string
  name: string
  email: string
  createdAt: string // ISO date string
  totalAmount: number
  totalAmount30day: number
  totalAmount60day: number
  totalAmount90day: number
  totalAmount120day: number
  totalPurchase30day: number
  totalPurchase60day: number
  totalPurchase90day: number
  totalPurchase120day: number
  accountManagerData: any | null // you can replace `any` with a specific type if you know the structure
  salesData: any | null // same here
  source?: string
  tags: Tag[]
  smsStatus: string
}

type ManagerData = {
  _id: string
  name: string
  email: string
}

type SalesPurchaseCredit = {
  _id: string
  allowedMessages: number
  manual: boolean
  status: string
  paidFrom: string
  purchasedDate: string
  product: string
  productName: string | null
  user: string
  invoice: string
  invoicePdf: string
  type: string
  amount: number
  createdAt: string // ISO date string
  updatedAt: string // ISO date string
  __v: number
  totalAmountWithoutGST: number
}

export type SalesGraphData = {
  group: string
  key: string
  data: {
    [key: string]: number
  }
}

export type SalesAllPurchase = {
  industry: string
  accountManager: string
  sales: string
  smsStatus: string
  salesType: string
  _id: string
  name: string
  email: string
  createdAt: string // ISO date string
  mobile: string
  amount: number
  credits: SalesPurchaseCredit[] // replace `any` with a more specific type if you know what is inside credits
  totalAmountWithoutGST: number
  accountManagerData?: ManagerData
  salesData?: ManagerData
  source?: string
  tags: Tag[]
}

export type AdminReportFilter = {
  from: string
  to: string
  page: number
  limit: number
  mode?: 'list' | 'export'
  source?: string
  requestFrom?: string
  status?: string
  userIds?: string
  sourceDestination?: string
  gateway?: string
  groupBy?: null | string
  timeFrame?: string
}

// Coupon
export type CouponFilter = {
  status?: boolean
  type?: string
  staffId?: string
  discountType?: string
  search?: string
  page: number
  limit: number
}

export type Coupons = {
  _id: string
  code: string
  description: string
  type: string
  discountType: string
  flatRate: number
  percentageOff: number
  freeCredit: number
  customers: {
    _id: string
    userId: string
    assignedAt: string
    expiredAt: string
  }[]
  status: boolean
  minCredit: number
  maxCredit: number
  commisionRate: number
  staffId: {
    _id: string
    name: string
    email: string
  }
  staffName: string
  expiredDay: string
  expiredAt: string
  createdAt: string
}

export type CouponPayload = {
  code: string
  description: string
  type: string
  discountType: string
  flatRate: number
  percentageOff: number
  freeCredit: number
  status: boolean
  minCredit: number
  maxCredit: number
  commisionRate: number
  staffId: string
}

// Plan Access
export interface Product {
  _id: string
  isActive: boolean
  hasTrial: boolean
  trialDays: number
  productKey: string
  name: string
  description: string
  tags: string[] | null
  promoteVideoUrl: string | null
  promoteImageUrl: string | null
  promoteCTA: string | null
  createdAt: string
  updatedAt: string
  __v: number
  stripeProductId: string
}

export interface ProductPlan {
  _id: string
  features: string[]
  isActive: boolean
  hasTrial: boolean
  productId: Product
  planKey: string
  name: string
  description: string
  price: number
  billingInterval: string
  quotaLimit: number
  createdAt: string
  updatedAt: string
  __v: number
  stripePriceId?: string
  subscriptionId?: string
}

export interface ProductPlanResponseData {
  plans: ProductPlan[]
  product_key: string
  product?: Product
}

// Type for ProductPlan when returned in subscription response (where productId is just a string ID)
export interface SubscriptionProductPlan {
  _id: string
  features: string[]
  isActive: boolean
  hasTrial: boolean
  productId: string // In subscription response, this is just the ID
  planKey: string
  name: string
  description: string
  price: number
  billingInterval: string
  quotaLimit: number
  createdAt: string
  updatedAt: string
  __v: number
  stripePriceId?: string
}

export interface Subscription {
  _id: string
  cancelAtPeriodEnd: boolean
  isTrial: boolean
  trialDays: number | null
  userId: string
  productId: Product
  planId: SubscriptionProductPlan
  stripeSubscriptionId: string
  status: string
  currentPeriodStart: number
  currentPeriodEnd: number
  cancelAt: number | null
  cancelReason: string | null
  trialStart: number | null
  trialEnd: number | null
  createdAt: string
  updatedAt: string
  __v: number
}

// Invoice related interfaces
export interface TaxRate {
  id: string
  object: string
  active: boolean
  country: string
  created: number
  description: string
  display_name: string
  effective_percentage: number | null
  flat_amount: number | null
  inclusive: boolean
  jurisdiction: string | null
  jurisdiction_level: string | null
  livemode: boolean
  metadata: Record<string, any>
  percentage: number
  rate_type: string
  state: string | null
  tax_type: string | null
}

export interface TaxAmount {
  amount: number
  inclusive: boolean
  tax_rate: string
  taxability_reason: string | null
  taxable_amount: number
}

export interface Tax {
  amount: number
  tax_behavior: string
  tax_rate_details: {
    tax_rate: string
  }
  taxability_reason: string
  taxable_amount: number
  type: string
}

export interface ProrationDetails {
  credited_items: {
    invoice: string
    invoice_line_items: string[]
  } | null
}

export interface SubscriptionItemDetails {
  invoice_item: string | null
  proration: boolean
  proration_details: ProrationDetails
  subscription: string
  subscription_item: string
}

export interface Parent {
  invoice_item_details: any | null
  subscription_item_details: SubscriptionItemDetails
  type: string
}

export interface Period {
  end: number
  start: number
}

export interface Plan {
  id: string
  object: string
  active: boolean
  aggregate_usage: any | null
  amount: number
  amount_decimal: string
  billing_scheme: string
  created: number
  currency: string
  interval: string
  interval_count: number
  livemode: boolean
  metadata: Record<string, any>
  meter: any | null
  nickname: string | null
  product: string
  tiers_mode: any | null
  transform_usage: any | null
  trial_period_days: number | null
  usage_type: string
}

export interface Recurring {
  aggregate_usage: any | null
  interval: string
  interval_count: number
  meter: any | null
  trial_period_days: number | null
  usage_type: string
}

export interface Price {
  id: string
  object: string
  active: boolean
  billing_scheme: string
  created: number
  currency: string
  custom_unit_amount: any | null
  livemode: boolean
  lookup_key: string | null
  metadata: Record<string, any>
  nickname: string | null
  product: string
  recurring: Recurring
  tax_behavior: string
  tiers_mode: any | null
  transform_quantity: any | null
  type: string
  unit_amount: number
  unit_amount_decimal: string
}

export interface Pricing {
  price_details: {
    price: string
    product: string
  }
  type: string
  unit_amount_decimal: string | null
}

export interface LineItem {
  id: string
  object: string
  amount: number
  amount_excluding_tax: number
  currency: string
  description: string
  discount_amounts: any[]
  discountable: boolean
  discounts: any[]
  invoice: string
  livemode: boolean
  metadata: Record<string, any>
  parent: Parent
  period: Period
  plan: Plan
  pretax_credit_amounts: any[]
  price: Price
  pricing: Pricing
  proration: boolean
  proration_details: ProrationDetails
  quantity: number
  subscription: string
  subscription_item: string
  tax_amounts: TaxAmount[]
  tax_rates: TaxRate[]
  taxes: Tax[]
  type: string
  unit_amount_excluding_tax: string
}

export interface Lines {
  object: string
  data: LineItem[]
  has_more: boolean
  total_count: number
  url: string
}

export interface AutomaticTax {
  disabled_reason: string | null
  enabled: boolean
  liability: any | null
  provider: any | null
  status: any | null
}

export interface Issuer {
  type: string
}

export interface StatusTransitions {
  finalized_at: number | null
  marked_uncollectible_at: number | null
  paid_at: number | null
  voided_at: number | null
}

export interface PaymentSettings {
  default_mandate: any | null
  payment_method_options: any | null
  payment_method_types: any | null
}

export interface Rendering {
  amount_tax_display: string
  pdf: {
    page_size: string
  } | null
  template: any | null
  template_version: any | null
}

export interface RenderingOptions {
  amount_tax_display: string
}

export interface SubscriptionDetails {
  metadata: Record<string, any>
  subscription: string
}

export interface ParentDetails {
  quote_details: any | null
  subscription_details: SubscriptionDetails
  type: string
}

export interface Invoice {
  id: string
  object: string
  account_country: string
  account_name: string
  account_tax_ids: any | null
  amount_due: number
  amount_overpaid: number
  amount_paid: number
  amount_remaining: number
  amount_shipping: number
  application: any | null
  application_fee_amount: any | null
  attempt_count: number
  attempted: boolean
  auto_advance: boolean
  automatic_tax: AutomaticTax
  automatically_finalizes_at: number | null
  billing_reason: string
  charge: string | null
  collection_method: string
  created: number
  currency: string
  custom_fields: any | null
  customer: string
  customer_address: any | null
  customer_email: string
  customer_name: string
  customer_phone: string | null
  customer_shipping: any | null
  customer_tax_exempt: string
  customer_tax_ids: any[]
  default_payment_method: any | null
  default_source: any | null
  default_tax_rates: TaxRate[]
  description: string
  discount: any | null
  discounts: any[]
  due_date: number | null
  effective_at: number | null
  ending_balance: number | null
  footer: string
  from_invoice: any | null
  hosted_invoice_url: string | null
  invoice_pdf: string | null
  issuer: Issuer
  last_finalization_error: any | null
  latest_revision: any | null
  lines: Lines
  livemode: boolean
  metadata: Record<string, any>
  next_payment_attempt: number | null
  number: string | null
  on_behalf_of: any | null
  paid: boolean
  paid_out_of_band: boolean
  parent: ParentDetails
  payment_intent: string | null
  payment_settings: PaymentSettings
  period_end: number
  period_start: number
  post_payment_credit_notes_amount: number
  pre_payment_credit_notes_amount: number
  quote: any | null
  receipt_number: string | null
  rendering: Rendering
  rendering_options: RenderingOptions
  shipping_cost: any | null
  shipping_details: any | null
  starting_balance: number
  statement_descriptor: string | null
  status: string
  status_transitions: StatusTransitions
  subscription: string
  subscription_details: SubscriptionDetails
  subtotal: number
  subtotal_excluding_tax: number
  tax: number
  test_clock: any | null
  total: number
  total_discount_amounts: any[]
  total_excluding_tax: number
  total_pretax_credit_amounts: any[]
  total_tax_amounts: TaxAmount[]
  total_taxes: Tax[]
  transfer_data: any | null
  webhooks_delivered_at: number | null
}

// Generic Stripe-style paginated list type
export interface PaginatedList<T> {
  object: string
  data: T[]
  has_more: boolean
  url?: string
}

// API payload wrapper for invoices list
export interface InvoiceListResponse {
  list: PaginatedList<Invoice>
}

export interface ProductQuotaStatus {
  hasQuota: boolean
  remaining: number
  total: number
  resetDate: number
  isTrial: boolean
  used?: number
}

export interface ProductSubscriptionResponseData {
  subscriptions: Subscription[]
  quotas: Record<string, ProductQuotaStatus>
}

export interface ProductAccessQuotaStatus {
  hasQuota: boolean
  remaining: number
  total: number
  resetDate: string | null
  isTrial: boolean
  used?: number
}

export interface ProductAccessResponseData {
  productKey: string
  hasAccess: boolean
  quotaStatus: ProductAccessQuotaStatus
  product?: Product
}

export interface PurchaseProductPlanRequest {
  productId: string
  planId: string
  card?: string
  priceId?: string
  token?: string
  isTrial?: boolean
}

export interface ProductQuotaResponseData {
  quota: number
  product_key: string
  quota_usage: QuotaUsage
}

export interface QuotaUsage {
  currentUsage: number
  quotaLimit: number
  remaining: number
  isUnlimited: boolean
  resetDate: number
  isTrial: boolean
}
export interface UpcomingInvoiceData {
  invoice: {
    planId: string
    userId: string
    pricing: {
      subtotal: number
      tax: number
      total: number
      currency: string
      formatted: {
        subtotal: string
        tax: string
        total: string
      }
    }
    planDetails: {
      name: string
      interval: string
      intervalCount: number
    }
    taxRates: {
      id: string
      displayName: string
      percentage: number
    }[]
  }
}

export interface UpcomingInvoiceChangePlanData {
  changePreview: {
    currentPlanId: string
    newPlanId: string
    userId: string
    applyNow: boolean
    type: string
    currentPlan?: {
      amount: number
      currency: string
      name: string
      interval: string
      intervalCount: number
    }
    newPlan?: {
      amount: number
      currency: string
      name: string
      interval: string
      intervalCount: number
    }
    difference?: {
      amount: number
      currency: string
      formatted: string
      isUpgrade: boolean
      isDowngrade: boolean
    }
    proration?: {
      subtotal: number
      tax: number
      total: number
      currency: string
      formatted: {
        subtotal: string
        tax: string
        total: string
      }
    }
    nextBilling: {
      amount: number
      currency: string
      interval: string
      intervalCount: number
    }

    effectiveDate: string
    taxRates: TaxRate[]
    planDetails: {
      name: string
      interval: string
      intervalCount: number
    }
    planId: string
    pricing: {
      currency: string
      formatted: {
        subtotal: string
        tax: string
        total: string
      }
      subtotal: number
      tax: number
      total: number
    }
  }
}

export interface TaxRate {
  id: string
  displayName: string
  percentage: number
}

export enum PreviewType {
  new_subscription = 'new_subscription',
  subscription_change = 'subscription_change',
}

export interface CancelReasonData {
  reasons: {
    _id: string
    reason: string
    order: number
  }[]
}

export interface PaymentMethodCard {
  id: string
  object: string
  address_city: string | null
  address_country: string | null
  address_line1: string | null
  address_line1_check: string | null
  address_line2: string | null
  address_state: string | null
  address_zip: string | null
  address_zip_check: string | null
  allow_redisplay: string
  brand: string
  country: string
  customer: string
  cvc_check: string
  dynamic_last4: string | null
  exp_month: number
  exp_year: number
  fingerprint: string
  funding: string
  last4: string
  metadata: Record<string, any>
  name: string | null
  regulated_status: string
  tokenization_method: string | null
  wallet: any | null
}

export type ProductAccessResponse = AppResponse<ProductAccessResponseData>
export type ProductPlanResponse = AppResponse<ProductPlanResponseData>
export type ProductQuotaResponse = AppResponse<ProductQuotaResponseData>
export type ProductSubscriptionResponse = AppResponse<ProductSubscriptionResponseData>
export type UpcomingInvoice = AppResponse<UpcomingInvoiceData>
export type UpcomingInvoiceChangePlan = AppResponse<UpcomingInvoiceChangePlanData>
export type CancelReason = AppResponse<CancelReasonData>

export enum ProductPlanTier {
  FREE = 'free',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
  BASIC = 'basic',
  BUSINESS = 'business',
}

export interface UserSubscription {
  subscriptions: {
    items: Subscription[]
    total: number
    limit: number
    totalPages: number
    current: number
    pagingCounter: number
    hasPrevPage: boolean
    hasNextPage: boolean
    prevPage: number | null
    nextPage: number | null
  }
  quotas: {
    [key: string]: QuotaUsage
  }
}

export interface CreditCheck {
  status: boolean
  message: string
  totalDeductibleCredits: number
  requiredCredits: number
  currentCredits: number
}

export enum ProductKey {
  LIVECHAT = 'livechat',
  BCARD = 'bcard',
}

// Sinch In-App Calling Types
export type SinchTokenData = {
  token: string
  userId: string
  expiresAt: string
  applicationKey: string
  callerNumber: string
  environmentHost: string
}

export type SinchTokenResponse = AppResponse<SinchTokenData>

// Activity Log Types
export type ActivityLogType =
  | 'profile_updated'
  | 'tag_added'
  | 'tag_removed'
  | 'message_sent'
  | 'message_received'
  | 'task_created'
  | 'task_completed'
  | 'note_added'
  | 'contact_created'
  | 'contact_deleted'
  | 'subscription_changed'
  | 'unknown'

export interface ActivityLogPerformedBy {
  _id: string
  firstName?: string
  lastName?: string
  email?: string
  name?: string
}

export interface ActivityLogChange {
  field: string
  oldValue: string
  newValue: string
}

export interface ActivityLogMeta {
  changes?: ActivityLogChange[]
  contactId?: string
  updatedFields?: string[]
  tagName?: string
  taskId?: string
  [key: string]: any
}

export interface ActivityLogItem {
  _id: string
  id: string
  message: string
  isSMS: boolean
  sendTime: string
  activityType: ActivityLogType
  content: string
  meta?: ActivityLogMeta
  user: string
  performedBy?: ActivityLogPerformedBy
  phoneNumber: string
  requestName: string
  createdBy: string
  createdAt: string
  updatedAt: string
}

export interface ActivityLogResponse {
  items: ActivityLogItem[]
  total: number
  limit: number
  totalPages: number
  current: number
  pagingCounter: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}

export type GetActivityLogParams = {
  page?: number
  limit?: number
}

// Notes Timeline Types
export type NoteType = 'manual' | 'voice'

export interface NoteVoiceContent {
  voiceId: string
  summary: string
  highlights: string[]
  actionItems: string[]
  sentiment: string
  leadIntent: string
  transcriptExcerpt: string
  welcomeMessage: string
}

export interface NoteManualContent {
  text: string
}

export type NoteContent = NoteManualContent | NoteVoiceContent

export interface NoteTimelineItem {
  _id: string
  id: string
  createdBy: string
  rawContactId: string
  createdAt: string
  updatedAt: string
  type: NoteType
  content: NoteContent
}

export interface NotesTimelineResponse {
  items: NoteTimelineItem[]
  total: number
  limit: number
  current: number
  totalPages: number
  hasPrevPage: boolean
  hasNextPage: boolean
  prevPage: number | null
  nextPage: number | null
}

export interface CreateNotePayload {
  phoneNumber: string
  noteText: string
}
